<template>
  <v-layout row justify-center>
    <v-dialog v-model="projectionFormShow" persistent max-width="600px">
      <v-card>
        <v-card-title class="pb-0">
          <span class="headline">Editar projeção por período</span>
          <v-subheader
            class="px-0"
          >Para editar apenas um mês escolha a data final igual a data inicial</v-subheader>
        </v-card-title>
        <v-card-text class="pt-0">
          <v-form ref="editProjectionForm" v-model="validForm" lazy-validation class="mt-0 pt-0">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs6 px-3>
                  <v-menu
                    :disabled="true"
                    v-model="initMonthMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="initMonthFormated"
                        label="Data inicial"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :disabled="true"
                      type="month"
                      no-title
                      v-model="formData.initMonth"
                      @input="initMonthMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6 px-3>
                  <v-menu
                    v-model="endMonthMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        clearable
                        v-model="endMonthFormated"
                        label="Data final"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      type="month"
                      no-title
                      v-model="formData.endMonth"
                      @input="endMonthMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6 px-3>
                  <v-text-field
                    prefix="R$ "
                    id="projectionField"
                    v-money="$store.state.maskMoney.BRL"
                    v-model="formData.projection"
                    label="Novo valor da projeção"
                    :rules="$store.state.formRules.required"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blueGrey darken-1" flat @click="closeProjectionForm">Cancelar</v-btn>
          <v-btn color="primary" flat @click="doSave">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { VMoney } from "v-money";
import * as moment from "moment";
const defaultProjectionForm = {
  provided_id: "",
  projection: "",
  initMonth: "",
  endMonth: ""
};
export default {
  directives: {
    money: VMoney
  },
  props: {
    generate: Function,
    projectionFormShow: Boolean,
    projectionFormValue: Object,
    closeProjectionForm: Function
  },
  computed: {
    initMonthFormated: {
      get() {
        return this.formData.initMonth
          ? moment(this.formData.initMonth).format("MM/YYYY")
          : "";
      },
      set(value) {
        if (value) {
          this.formData.initMonth = moment(value).format("MM/YYYY");
        } else {
          this.formData.initMonth = "";
        }
      }
    },
    endMonthFormated: {
      get() {
        return this.formData.endMonth
          ? moment(this.formData.endMonth).format("MM/YYYY")
          : "";
      },
      set(value) {
        if (value) {
          this.formData.endMonth = moment(value).format("MM/YYYY");
        } else {
          this.formData.endMonth = "";
        }
      }
    }
  },
  watch: {
    projectionFormShow(val) {
      //console.log(val.length);
      document.getElementById("projectionField").value = "";
      this.formData = { ...defaultProjectionForm };
      this.$refs.editProjectionForm.resetValidation();
      if (val) {
        this.formData = { ...this.projectionFormValue };
      }
    }
  },
  data() {
    return {
      validForm: true,
      initMonthMenu: false,
      endMonthMenu: false,
      formData: { ...defaultProjectionForm }
    };
  },
  methods: {
    async doSave() {
      let query = {};
      query.initMonth = this.formData.initMonth;
      query.endMonth = this.formData.endMonth;
      query.provided_id = this.formData.provided_id;
      query.projection = this.formData.projection
        .split(".")
        .join("")
        .replace(",", ".");
      let obj = {
        url: "/api/provided/" + this.formData.provided_id,
        query: query,
        method: "patch"
      };
      this.$store.dispatch("request/doRequest", obj).then(response => {
        let opts = {
          message: response.data.message,
          type: "success"
        };
        this.$store.commit("showAlert", opts);
        this.closeProjectionForm();
        this.generate('rec');
        //console.log(response.data);
      });
    }
  }
};
</script>

<style>
</style>